import React, {Component} from 'react';
import styled from 'styled-components'
import {Avatar, Block, Divider} from "reakit";
import {Box, Flex, Heading, Text} from 'rebass';
import {Container, DesktopBox, MobileHeader} from "../../components/Base";
import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
import {withRouter} from "react-router";

import WavePopup from '../../components/WavePopup'
import MobileProfile from "../../components/StudentSummary/MobileProfile";
import MobileWaves from "../../components/StudentSummary/MobileWaves";
import MobileLeaves from "../../components/StudentSummary/MobileLeaves";

import ContactMethod from '../../components/Modals/ContactMethod'
import MobileConfirmRemove from '../../components/Modals/MobileConfirmRemove'

import {schoolSelectors} from "../../store/school";


const FixedControls = styled(Box)`
  position: relative;
  bottom: -20px;
  
  z-index: 9990;
  width: 100%;

`;

class RosterProfile extends Component {
	roster = this.props.match.params.roster;

	state = {
		contactPopup: false
	}


	handleContact = async () => {
		const {firebase, data, profile, isFaculty, history} = this.props;
		let status = 0;
		if (isFaculty) {
			status = 1
		}
		let accepted = {status: status, updated_at: Math.floor(Date.now() / 1000)};

		const members = [profile.id, data.id];

		const result = await this.checkIfExists(members);


		if (result !== true) {
			let newChatRef = firebase.chats().doc();
			newChatRef.set({
				creator_uid: profile.id,
				is_group: false,
				members: members,
				post_time: Math.floor(Date.now() / 1000),
				last_updated: Math.floor(Date.now() / 1000),
				messages: [],
				accepted,
				name: ''
			})
			history.push(`/app/chat/${newChatRef.id}`);

		}
	};
	//
	handleRemoveStudent = async () => {
		const currentStudent = this.props.data;
		const {firebase, roster, history} = this.props;
		const selected = roster.students_uid.filter(student_uid => student_uid !== currentStudent.id)
		try {

			let rosterRef = await firebase.roster(roster.id);
			let chatRef = await firebase.chat(roster.chat_uid);
			rosterRef.update({
				students_uid: selected
			});
			const chatMembers = [...selected, ...roster.shared_with];
			chatRef.update({
				members: chatMembers
			});
			// updateStudents(students.filter(student => selected.includes(student.id)))
			// this.setState({currentStudent: null, detailsView: false})
			history.replace('app/roster')
			history.push(`/app/roster/${roster.id}`)
		} catch (e) {
			//console.log('error', e)
		}
	}

	toggleContact = () => {
		const {contactPopup} = this.state;
		this.setState({contactPopup: !contactPopup})
	}

	checkIfExists = async (members) => {
		const {firebase, history} = this.props;
		try {
			let chatQuery = await firebase.chats().where('members', 'array-contains', members[0]).where('creator_uid', '==', members[1]).where('is_group', '==', false).get();
			//console.log('chatquery', chatQuery);
			if (chatQuery.docs.length > 0) {
				history.push(`/app/chat/${chatQuery.docs[0].id}`);
				return true
			} else {
				chatQuery = await firebase.chats().where('members', 'array-contains', members[1]).where('creator_uid', '==', members[0]).where('is_group', '==', false).get();
				if (chatQuery.docs.length > 0) {
					history.push(`/app/chat/${chatQuery.docs[0].id}`);
					return true
				}
			}
		} catch (err) {

			//console.log(err)
		}
		return false
	};



	render() {

		const { data, schoolInfo, profile, isFaculty} = this.props;

		let currentLocation = 'Unknown'
		if(data.on_leave && schoolInfo){
			currentLocation = schoolInfo.leaveTypes[data.leave_type].name
		} else if(schoolInfo && data.current_location){
			let locationData = schoolInfo.locations.map[data.current_location]
			if(locationData !== undefined){
				currentLocation = locationData.name
			}
		}
		return (
			<Box>
				<MobileHeader>
					<Heading pt={3}>{data.first_name}'s Profile</Heading>
					<Text color={'meta'} fontSize={'17px'} fontWeight={600} pb={2}>{currentLocation}</Text>
					<FixedControls>
						<Flex width={1} justifyContent={['center']}>
							<WavePopup isFaculty={isFaculty} student={data} profile={profile} school={schoolInfo} hideLocation/>
						</Flex>
					</FixedControls>
				</MobileHeader>

				<Block>
					<Container>
						<Box width={1} pt={[3, 4]} pb={3}>
							<Flex>
								<Box>
									<Heading as={'h5'} >{data.first_name} {data.last_name}</Heading>
									<ContactMethod profile={data} handleChat={this.handleContact} noButton/>
									{/*<Flex flexDirection={'row'} pb={4}>*/}
									{/*	<Text color={'meta'} mr={1} onClick={this.toggleContact}>Contact </Text>*/}
									{/*	<IosArrowForward fontSize={'16px'} color={'#969a9b'}/>*/}
									{/*</Flex>*/}
								</Box>
								<Box ml={'auto'}/>
								<Box>
									<Avatar src={data.profile_pic} width={'43px'} height={'43px'} backgroundColor={'#707070'}/>
								</Box>
							</Flex>
						</Box>
						<MobileProfile profile={data}/>
						<Divider/>
						<MobileWaves profile={data} locations={schoolInfo.locations} {...this.props}/>
						<Divider/>

						<MobileLeaves profile={data}/>

						<Flex justifyContent={'center'} pt={4}>
							<MobileConfirmRemove profile={data} handleConfirm={this.handleRemoveStudent}/>
						</Flex>
						<DesktopBox>
							<FixedControls>
								<Flex width={1} justifyContent={['center']}>
									<WavePopup isFaculty={isFaculty} student={data} profile={profile} school={schoolInfo} hideLocation/>
								</Flex>
							</FixedControls>
						</DesktopBox>
					</Container>
				</Block>
			</Box>
		);
	}
}

const mapStateToProps = state => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	search: searchSelectors.refreshSearch(state.search),
	filters: searchSelectors.refreshFilters(state.search),
	students: searchSelectors.refreshCurrentResults(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	}
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RosterProfile));


